// p4 END OF THE GAME: "the Tents are opened and players count their
// treasures. Treasures are valued as follows: Turquoise - 1, Obsidian - 5,
// Gold - 10, Artifacts - 5 and 10."
//
// The three gem denominations are only a way of making change on a real
// table; nothing in the rules ever cares which stones a total is made of, so
// this engine carries the number and not the pile.

/**
 * A player's final wealth. Only what made it into the tent counts - anything
 * still in a pocket when the last round ended is, by definition, not there.
 */
export const totalFor = (player) => player.tent + player.artifactPoints;

/**
 * p4: "The player with the most wealth (in treasure value) wins. If scores
 * are tied, the player with the most Artifacts wins. If still tied, play
 * again!"
 *
 * "Play again" is not something software can do to you, so a tie that
 * survives the artifact count is reported as a shared win. Ranks use
 * competition numbering (1, 2, 2, 4) so two genuinely-tied players read as
 * tied rather than one of them silently losing on array order.
 */
export const scoreboard = (state) => {
  const rows = state.players.map((p) => ({
    id: p.id,
    name: p.name,
    seat: p.seat,
    tent: p.tent,
    artifacts: p.artifacts,
    artifactPoints: p.artifactPoints,
    total: totalFor(p),
  }));

  const ordered = [...rows].sort((a, b) => (
    b.total - a.total || b.artifacts - a.artifacts || a.seat - b.seat
  ));

  const ties = (a, b) => a.total === b.total && a.artifacts === b.artifacts;

  let rank = 0;
  return ordered.map((row, i) => {
    if (i === 0 || !ties(row, ordered[i - 1])) rank = i + 1;
    return { ...row, rank, isWinner: rank === 1 };
  });
};

export const winners = (state) => scoreboard(state).filter((row) => row.isWinner);
